import React, { useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_specific_tenant_sales_rep_budget_allocation_details, loading_retrieve_specific_tenant_sales_rep_budget_allocation_details, reset_retrieve_specific_tenant_sales_rep_budget_allocation_details, success_retrieve_specific_tenant_sales_rep_budget_allocation_details } from '../../reducers/auth_tenant/retrieve_specific_tenant_sales_rep_budget_allocation_details_Slice';
import { RETRIEVE_TENANT_SPECIFIC_SALES_REP_BUDGET_ALLOCATION_DETAILS_API } from '../../api/api_data';
import { RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { formatNumber, formatToSentenceCase, messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";
import { useDispatch } from 'react-redux';
import { Block, BlockBetween, BlockHead, BlockTitle, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../Component';
import CardTabs from '../../pages/components/cards/CardTabs';
import moment from 'moment';
import { Line } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import TenantUpdateSalesRepBudgetAllocationValueModal from './TenantUpdateSalesRepBudgetAllocationValueModal';

// Register necessary components
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler, Legend);

const ViewSalesRepBudgetAllocationDetails = ({ isOpen, closeModal, data, tenant_info, user_info, successFunction }) => {

  const [page_data, setPageData] = useState(data);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const [orderItemPerPage] = useState(10);
  const [currentOrdersPage, setCurrentOrdersPage] = useState(1);
  const [update_budget_allocation_modal, setUpdateBudgetAllocationModal] = useState(false);

  const toggleBudgetAllocationModal = () => setUpdateBudgetAllocationModal(!update_budget_allocation_modal);

  const paginate_orders = (pageNumber) => setCurrentOrdersPage(pageNumber);

  useEffect(() => {
    if (isOpen)
    {
      retrieve_page_data(data?.id);
    }
    setPageData(data);
    setOpen(isOpen);
  }, [data, isOpen]);

  const retrieve_page_data = (received_id) => {
    setError("");
    setLoading(true);
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_specific_tenant_sales_rep_budget_allocation_details, success_retrieve_specific_tenant_sales_rep_budget_allocation_details, fail_retrieve_specific_tenant_sales_rep_budget_allocation_details, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SPECIFIC_SALES_REP_BUDGET_ALLOCATION_DETAILS_API}/${received_id}`));
  };

  // Listener
  const retrieve_specific_tenant_sales_rep_budget_allocation_details_listener = useSelector((state) => state.retrieve_specific_tenant_sales_rep_budget_allocation_details.retrieve_specific_tenant_sales_rep_budget_allocation_details);

  useEffect(() => {
    if (retrieve_specific_tenant_sales_rep_budget_allocation_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_specific_tenant_sales_rep_budget_allocation_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_specific_tenant_sales_rep_budget_allocation_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_specific_tenant_sales_rep_budget_allocation_details_listener.message);
          messageToast(retrieve_specific_tenant_sales_rep_budget_allocation_details_listener.message, app_consts.FAIL);
        } else if (retrieve_specific_tenant_sales_rep_budget_allocation_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_specific_tenant_sales_rep_budget_allocation_details_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_specific_tenant_sales_rep_budget_allocation_details());
      }
    }
  }, [retrieve_specific_tenant_sales_rep_budget_allocation_details_listener]);

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Orders"
    },
    {
      tabName: "Analytics"
    }
  ];
  const orderStats = [
    {
      label: "Total Orders",
      value: page_data?.total_orders || "0",
      icon: "box",
      color: "#6576ff",
      bg: "rgba(101, 118, 255, 0.1)",
    },
    {
      label: "Approved Orders",
      value: page_data?.approved_orders || "0",
      icon: "check-circle",
      color: "#1ee0ac",
      bg: "rgba(30, 224, 172, 0.1)",
    },
    {
      label: "Pending Submission Orders",
      value: page_data?.pending_submission_orders || "0",
      icon: "clock",
      color: "#f4bd0e",
      bg: "rgba(244, 189, 14, 0.1)",
    },
    {
      label: "Cancelled Orders",
      value: page_data?.cancelled_orders || "0",
      icon: "cross-circle",
      color: "#e85347",
      bg: "rgba(232, 83, 71, 0.1)",
    },
    {
      label: "Rejected Orders",
      value: page_data?.rejected_orders || "0",
      icon: "alert-circle",
      color: "#ff63a5",
      bg: "rgba(255, 99, 165, 0.1)",
    },
    {
      label: "Pending Reviews Orders",
      value: page_data?.pending_review_orders || "0",
      icon: "eye",
      color: "#09c2de",
      bg: "rgba(9, 194, 222, 0.1)",
    },
    {
      label: "Dispatched Orders",
      value: page_data?.dispatched_orders || "0",
      icon: "truck",
      color: "#8b6ef3",
      bg: "rgba(139, 110, 243, 0.1)",
    },
  ];

  // Get current list, pagination
  const indexOfLastOrderItem = currentOrdersPage * orderItemPerPage;
  const indexOfFirstOrderItem = indexOfLastOrderItem - orderItemPerPage;
  const currentOrderItems = page_data?.orders?.slice(indexOfFirstOrderItem, indexOfLastOrderItem);

  const chartData = {
    labels: page_data?.order_frequency?.map(d => d.date),        // x-axis: dates
    datasets: [
      {
        label: "Orders",
        data: page_data?.order_frequency?.map(d => d.count),    // y-axis: order counts
        fill: true,
        backgroundColor: "rgba(101, 118, 255, 0.2)",
        borderColor: "#6576ff",
        tension: 0.3,
        pointRadius: 4,
        pointBackgroundColor: "#6576ff",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: true, position: "top" },
      tooltip: { enabled: true },
    },
    scales: {
      x: { title: { display: true, text: "Date" } },
      y: { title: { display: true, text: "Number of Orders" }, beginAtZero: true },
    },
  };

  const update_budget_allocation_successFunction = () => {
    retrieve_page_data();
    successFunction();
  };


  return (
    <>
      <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size={"xl"}>
        <ModalHeader toggle={closeModal}>Sales Rep Budget Allocation Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Sales Rep Budget Allocation Details.</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        <Block>
                          <BlockBetween className="my-4">
                            {(user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.UPDATE_BUDGET_ALLOCATION)) && (
                              <>
                                <Button color="primary" size="sm" onClick={() => setUpdateBudgetAllocationModal(true)}>
                                  Update BUdget Allocation Value
                                </Button>
                              </>
                            )}
                          </BlockBetween>
                          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                        </Block>
                        {
                          activeCardTab === "Main Info" && (
                            <>
                              <div className="card-inner">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Main Information</BlockTitle>
                                  </BlockHead>
                                  <div className="profile-ud-list">
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Sales Rep</span>
                                        <span className="profile-ud-value">{page_data?.sales_rep?.name || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Budget Name</span>
                                        <span className="profile-ud-value">{page_data?.budget_allocation?.name || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Budget Name</span>
                                        <span className="profile-ud-value">{page_data?.agency?.name || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Budget Start Date</span>
                                        <span className="profile-ud-value">{page_data?.budget_allocation?.start_date ? moment(page_data?.budget_allocation?.start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Budget End Date Date</span>
                                        <span className="profile-ud-value">{page_data?.budget_allocation?.start_date ? moment(page_data?.budget_allocation?.start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Budget Allocated</span>
                                        <span className="profile-ud-value">{page_data?.sales_bud_allocation?.value ? `${formatNumber(page_data?.sales_bud_allocation?.value)} ZMW` : ""}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Budget Used</span>
                                        <span className="profile-ud-value">{page_data?.sales_bud_allocation?.used ? `${formatNumber(page_data?.sales_bud_allocation?.used)} ZMW` : ""}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Remaining Budget</span>
                                        <span className="profile-ud-value">{page_data?.sales_bud_allocation?.remaining ? `${formatNumber(page_data?.sales_bud_allocation?.remaining)} ZMW` : ""}</span>
                                      </div>
                                    </div>
                                  </div>
                                </Block>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Orders" && (
                            <>
                              <div className="card-inner">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Orders</BlockTitle>
                                  </BlockHead>
                                  <div className="nk-tb-list is-separate is-medium mb-3">
                                    <DataTableHead className="nk-tb-item">
                                      <DataTableRow>
                                        <span className="sub-text">Order</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="sub-text">No Of Products</span>
                                      </DataTableRow>
                                      <DataTableRow size="lg">
                                        <span className="sub-text">Date Created</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span className="sub-text">Status</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="sub-text">Action</span>
                                      </DataTableRow>
                                    </DataTableHead>
                                    {/*Head*/}
                                    {currentOrderItems?.length > 0
                                      ? currentOrderItems?.map((item) => (
                                        <DataTableItem key={item.id}>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  {item?.order_name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                </span>
                                                <span>{item?.order_ref_number || "--"} </span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  {item?.no_of_products || "0"}
                                                </span>
                                                <span>{item?.total_value ? `${parseFloat(item?.total_value)?.toFixed(2)} ZMW` : "--"}</span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow size="md">
                                            <div className="user-info">
                                              <span className="tb-lead">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                              {
                                                item?.order_date_type === app_consts.BACK_DATED_LOWER && (
                                                  <>
                                                    <span className="tb-odr-date">Backdate: {item?.backdated_date ? moment(item?.backdated_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                  </>
                                                )
                                              }
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow size="md">
                                            <span className="tb-odr-status">
                                              <Badge
                                                color={
                                                  item?.status === app_consts.APPROVED_LOWER || item?.status === app_consts.DISPATCHED_LOWER
                                                    ? "success"
                                                    : "warning"
                                                }
                                                className="badge-dot"
                                              >
                                                {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                              </Badge>
                                            </span>
                                          </DataTableRow>
                                          <DataTableRow className="nk-tb-col-tools">
                                            <div className="tb-odr-btns d-none d-sm-inline">
                                              <a
                                                href={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <Button color="primary" size="sm" className="btn btn-dim">
                                                  View
                                                </Button>
                                              </a>
                                            </div>
                                            <Button className="btn-pd-auto d-sm-none">
                                              <Icon name="chevron-right"></Icon>
                                            </Button>
                                          </DataTableRow>
                                        </DataTableItem>
                                      ))
                                      : null}
                                  </div>
                                  {currentOrderItems?.length > 0 && (
                                    <div className="mt-3">
                                      <PaginationComponent
                                        itemPerPage={orderItemPerPage}
                                        totalItems={page_data?.orders?.length}
                                        paginate={paginate_orders}
                                        currentPage={currentOrdersPage}
                                      />
                                    </div>
                                  )}
                                </Block>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Analytics" && (
                            <>
                              <div className="card-inner">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Analytics</BlockTitle>
                                  </BlockHead>
                                  <Row className="g-gs">
                                    {/* Stats Cards */}
                                    {orderStats?.map((stat, idx) => (
                                      <Col key={idx} xxl="3" sm="6">
                                        <Card
                                          style={{
                                            borderRadius: "8px",
                                            border: "1px solid #e5e9f2",
                                            transition: "all 0.3s ease",
                                            marginBottom: 0,
                                            height: "100%",
                                          }}
                                        >
                                          <div style={{ padding: "20px" }}>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                              <div>
                                                <h6 style={{ fontSize: "14px", color: "#6c757d", marginBottom: "8px" }}>
                                                  {stat.label}
                                                </h6>
                                                <h2 style={{ fontSize: "24px", fontWeight: "600", margin: 0 }}>
                                                  {stat.value}
                                                </h2>
                                              </div>
                                              <div
                                                style={{
                                                  width: "48px",
                                                  height: "48px",
                                                  borderRadius: "50%",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontSize: "24px",
                                                  backgroundColor: stat.bg,
                                                }}
                                              >
                                                <Icon name={stat.icon} style={{ color: stat.color }} />
                                              </div>
                                            </div>
                                          </div>
                                        </Card>
                                      </Col>
                                    ))}
                                  </Row>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Order Frequency</BlockTitle>
                                  </BlockHead>
                                  <Col xxl="12" md="12" style={{ marginBottom: '20px' }}>
                                    <Card style={{
                                      borderRadius: '8px',
                                      border: '1px solid #e5e9f2',
                                      height: '100%',
                                      overflow: 'hidden'
                                    }}>
                                      <div style={{ padding: '20px' }}>
                                        <div style={{ marginBottom: '16px' }}>
                                          <h6 style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>Order Frequency</h6>
                                        </div>
                                        <div style={{ height: '200px', position: 'relative', marginBottom: '16px' }}>
                                          <Line data={chartData} options={options} />
                                        </div>
                                      </div>
                                    </Card>
                                  </Col>
                                </Block>
                              </div>
                            </>
                          )
                        }
                        {/* Update Sales Rep Budget Allocation Valuee */}
                        {
                          (user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.UPDATE_BUDGET_ALLOCATION)) && (
                            <>
                              <TenantUpdateSalesRepBudgetAllocationValueModal isOpen={update_budget_allocation_modal} closeModal={toggleBudgetAllocationModal} data={{ id: data?.id }} tenant_info={tenant_info} user_info={user_info} successFunction={update_budget_allocation_successFunction} />
                            </>
                          )
                        }

                      </Row>


                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewSalesRepBudgetAllocationDetails;